export default {
  HIGH_SCHOOL: 'high school',
  COLLEGE: 'college',
  ACADEMY: 'academy',
}
